import { GET_DOC_ASSIST_WORD_SUMMARY } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type AssessmentSummaryResponse = UpdatedMedicalProfile;

export type UpdatedMedicalProfile = {
    condition_tag: string;
    condition_overview: string;
    therapy_regime?: {
        current?: {
            medicines?: {
                frequency: string;
                name: string;
            }[];
            time_info: {
                start: string;
                end: string;
            };
        };
        history?: {
            medicines?: Medicine[];
            time_info: TimeInfo;
        }[];
    };
    vital_status?: {
        vitals?: Vitals[];
        time_info: TimeInfo;
    }[];
};

export type Vitals = {
    name: string;
    progression: string;
    unit: string;
    interpretation: string;
};

export type Medicine = {
    frequency: string;
    name: string;
};

export type TimeInfo = {
    start?: string;
    end?: string;
};

export default (
    text: string,
    hash: string,
    ptId: string,
    modelId: string,
): Promise<AssessmentSummaryResponse> => {
    return fetchWithRefresh(GET_DOC_ASSIST_WORD_SUMMARY(text, hash, ptId, modelId), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('GET_DOC_ASSIST_WORD_SUMMARY failed');
        }
    });
};
